"use client";

import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer2 from "@/components/landing-page/Footer2";
import Cal, { getCalApi } from "@calcom/embed-react";

export default function ContactPage() {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: "discovery" });
      cal("ui", { theme: "light", hideEventTypeDetails: false, layout: "month_view" });
    })();
  }, []);

  return (
    <div className="min-h-screen bg-zinc-50 text-black selection:bg-indigo-100 relative flex flex-col">
      <Navbar isLoggedIn={false} />

      <main className="pt-32 pb-20 flex-grow flex flex-col items-center">
        <section className="px-6 w-full max-w-4xl mx-auto text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold tracking-tighter text-black mb-6">
            Book Your Free <span className="text-black">Strategy Call</span>
          </h1>
          <p className="text-lg md:text-xl text-zinc-700 max-w-2xl mx-auto">
            Choose a time that works best for you. You'll leave with a clear list of what to automate, what to build, and what to skip. No pitch, no pressure.
          </p>
        </section>

        <section className="w-full max-w-5xl mx-auto px-6 h-[700px]">
          <div className="w-full h-full bg-white border border-zinc-200 shadow-sm rounded-xl overflow-hidden p-2">
            <Cal 
              namespace="discovery"
              calLink="rajjainx/discovery"
              style={{ width: "100%", height: "100%", overflow: "scroll" }}
              config={{ layout: "month_view", useSlotsViewOnSmallScreen: "true", theme: "light" }}
            />
          </div>
        </section>
      </main>

      <Footer2 />
    </div>
  );
}
